import { Component } from "@angular/core";

@Component({
    templateUrl: 'external-pages.component.html',
    styleUrls: ['external-pages.component.scss']
})
export class ExternalPagesComponent { }